import Evented from './mixins/evented';

class Application extends Evented {
  constructor() {
    super(...arguments);

    this.lookup    = window.__VOONTO__.lookup;
    this.when      = window.__VOONTO__.when;
    this.whenUntil = window.__VOONTO__.whenUntil;
    this.promised  = window.__VOONTO__.promised;
    this.load      = window.__VOONTO__.load;
  }

//  require() {} // NOTE: requirejs
}

export default new Application();



// WEBPACK FOOTER //
// ./src/application.js